<template>
  <Modal v-model="finishDebtModal" width="400">
    <p slot="header" class="text-center">标记收款</p>
    <Form
      :model="formData"
      :rules="ruleValidate"
      ref="formData"
      :label-width="80"
    >
      <Row :gutter="8">
        <i-col span="24">
          <FormItem label="收款日期" prop="dueDate">
            <DatePicker type="date" placeholder="请设置收款日期" v-model="formData.dueDate"></DatePicker>
          </FormItem>
        </i-col>
        <i-col span="24">
          <FormItem label="备注" prop="dueRemark">
            <Input
              v-model.trim="formData.dueRemark"
              size="small"
              type="textarea"
              :rows="4"
              placeholder="填写备注"
            />
          </FormItem>
        </i-col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" class="m-r-5" @click="finishDebtModal = false">取消</Button>
      <Button
        type="success"
        class="m-r-5"
        :loading="btnLoading"
        @click="onConfirm()"
        >确认</Button
      >
    </div>
  </Modal>
</template>

<script>
import { ParseDate } from '@/utils/dateFormat'
import { finishDebt } from '@/api/invest/debt'

export default {
  data () {
    return {
      finishDebtModal: false,

      btnLoading: false,
      formData: {
        debtId: 0,
        dueDate: null,
        dueRemark: ''
      },
      ruleValidate: {
        dueDate: [
          { required: true, type: 'date', message: '收款日期不能为空', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    showModal (debtId) {
      this.formData.debtId = debtId
      this.finishDebtModal = true
    },
    onConfirm () {
      const _self = this
      _self.$refs.formData.validate((valid) => {
        if (valid) {
          _self.$Modal.confirm({
            title: '操作提示',
            content: '确定要完结当前收款单吗？完结后将无法修改条目',
            onOk: () => {
              _self.btnLoading = true
              _self.formData.dueDate = ParseDate(_self.formData.dueDate)

              finishDebt(_self.formData).then(res => {
                if (res && res.success) {
                  _self.$emit('on-success')
                  _self.$Notice.success({ desc: '操作成功' })
                }
              }).finally(() => {
                _self.btnLoading = false
                _self.finishDebtModal = false
              })
            }
          })
        }
      })
    }
  }
}
</script>
